export const updateCustomPage = `mutation UpdateCustomPage($input: UpdateCustomPageInput!) {
    updateCustomPage(input: $input) {
      id
      active
      companyId
      content
      dateCreated
      hideFromHeader
      pageNumber
      title
      userId
    }
  }
  `;
